<template lang="pug">
div
  AppTableColumn(
    v-slot="{ row }"
    header="Member"
    name="member"
    cell-classes="max-width"
    :sort-by="buildSortOptions('member')"
  )
    .insights-leaderboard-widget-member
      .d-flex.align-items-center.max-w-full(v-if="row.user.deactivated")
        AppAvatar(
          size="speck"
          :avatar="row.user.avatar_url"
        )
        .ellipsis {{ row.user.name }}
        i.hi.hi-info.ml-5(
          v-tooltip="tooltipOptions"
          :title="memberRemovedTooltip"
        )
      a.max-w-full.cursor-pointer(
        v-else
        @click.prevent="switchMember(row.user)"
      )
        .ellipsis
          AppAvatar(
            size="speck"
            :avatar="row.user.avatar_url"
          )
          span {{ row.user.name }}

  AppTableColumn(
    v-slot="{ row }"
    header="Time"
    name="time"
    :sort-by="buildSortOptions('time')"
  )
    .d-flex.align-items-center(v-if="row.tracked")
      .insights-leaderboard-widget-time
        | {{ row.tracked.current | formatDuration(false) }}
      InsightsMetric.leaderboard-metrics(
        :class="metricsClasses"
        type="time"
        :value="row.tracked.difference"
      )

  AppTableColumn(
    v-slot="{ row }"
    header="Activity"
    name="activity"
    :sort-by="buildSortOptions('activity')"
  )
    .d-flex.align-items-center(v-if="row.activity")
      InsightsActivityScore.mr-10(
        :score="row.activity.current || 0"
        size="small"
      )
      InsightsMetric.leaderboard-metrics(
        :class="metricsClasses"
        :value="row.activity.difference"
      )
  AppTableColumn(
    v-slot="{ row }"
    header="Idle Time"
    name="idle_time"
    :sort-by="buildSortOptions('idle_time')"
  )
    .d-flex.align-items-center(v-if="row.idle_time")
      InsightsActivityScore.mr-10(
        :score="row.idle_time.current"
        size="small"
        :upper-threshold="30"
        :lower-threshold="15"
        :higher-is-positive="false"
      )
      InsightsMetric.leaderboard-metrics(
        :class="metricsClasses"
        :value="row.idle_time.difference"
        invert-color
      )

  AppTableColumn(
    v-slot="{ row }"
    header="Core Work"
    name="core_time"
    :sort-by="buildSortOptions('core_time')"
  )
    .d-flex.align-items-center(v-if="row.core_time")
      InsightsProficiencyBadge.mr-10(
        :score="row.core_time.current"
        size="small"
      )
      InsightsMetric.leaderboard-metrics(
        :class="metricsClasses"
        type="number"
        :value="row.core_time.difference"
      )

  AppTableColumn(
    v-slot="{ row }"
    header="Achievements"
    name="achievements"
  )
    AppAchievementBadges.mr-10(
      v-if="hasAchievements(row)"
      :achievements="row.achievements"
      size="small"
    )
</template>

<script>
import InsightsActivityScore from './InsightsActivityScore.vue';
import InsightsProficiencyBadge from './InsightsProficiencyBadge.vue';
import InsightsMetric from './InsightsMetric.vue';
import AppAvatar from '~/components/AppAvatar.vue';
import AppAchievementBadges from '~/components/AppAchievementBadges.vue';
import { InsightsFilters, InsightsTracking } from '~/mixins';

export default {
  name: 'InsightsLeaderboardColumns',
  components: {
    InsightsActivityScore,
    InsightsProficiencyBadge,
    InsightsMetric,
    AppAvatar,
    AppAchievementBadges,
  },
  mixins: [InsightsFilters, InsightsTracking],
  props: {
    data: {
      type: Array,
      required: true,
    },
    showMetrics: {
      type: Boolean,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({ placement: 'top' }),
    memberRemovedTooltip: 'This member has been removed from the organization',
  }),
  computed: {
    metricsClasses() {
      return this.showMetrics ? '' : 'cloak';
    },
    rowsCount() {
      return this.data.length || 10;
    },
  },
  methods: {
    switchMember(user) {
      const string = `${user.id}_user_id`;

      this.setPreviousView({ previousView: this.selectedFilter, currentView: string });
      this.setSelectedFilter(string);
      this.setMembersFilter(string);
    },
    buildSortOptions(field) {
      return {
        field,
        direction: this.sortOptions.field === field ? this.sortOptions.direction : null,
      };
    },
    sort(options) {
      this.$emit('sort', options);
    },
    hasAchievements(row) {
      return row.achievements && row.achievements.length;
    },
  },
};
</script>
